export const DECEASED_PET_NUMBER_OF_DAYS_TO_SHOW = 28;

export const COMPANY_PHONE_NUMBER = '0330 9128077';
export const PITPAT_GPS_URL = 'https://www.pitpat.com/gps-tracker/';

export const ACCESS_TOKEN_KEY = 'access_token';
export const EMAIL_ACTIVATION_LINK_SENT = 'EMAIL_ACTIVATION_LINK_SENT';

export const INFO = 'INFO';

export const IDENTIBASE_PLUS_SUBSCRIPTION = 'IDENTIBASE_PLUS_SUBSCRIPTION';
export const IDENTIBASE_PLUS_SUBSCRIPTION_CHANGE_OF_DETAILS = 'IDENTIBASE_PLUS_SUBSCRIPTION_CHANGE_OF_DETAILS';
export const IDENTIALERT_SUBSCRIPTION = 'IDENTIALERT_SUBSCRIPTION';
export const IDENTIFIND_SUBSCRIPTION = 'IDENTIFIND_SUBSCRIPTION';
export const PITPAT_SUBSCRIPTION = 'PITPAT';
export const TRANSFER_OF_KEEPERSHIP_PLUS_IDENTIALERT = 'TRANSFER_OF_KEEPERSHIP_PLUS_IDENTIALERT';
export const TRANSFER_OF_KEEPERSHIP_BREEDER = 'TRANSFER_OF_KEEPERSHIP_BREEDER';

export const IDENTIBASE_PLUS_SUBSCRIPTION_ADESTRA_TAG = 'identibase+';
export const IDENTIBASE_PLUS_SUBSCRIPTION_CHANGE_OF_DETAILS_ADESTRA_TAG = 'identibase+cod';
export const IDENTIALERT_SUBSCRIPTION_ADESTRA_TAG = 'identialert';
export const IDENTIFIND_SUBSCRIPTION_ADESTRA_TAG = 'identifind';
export const PITPAT_SUBSCRIPTION_ADESTRA_TAG = 'pitpat';
export const UNIDENTIFIED_SUBSCRIPTION_ADESTRA_TAG = 'unidentified';
export const TRANSFER_OF_KEEPERSHIP_PLUS_IDENTIALERT_ADESTRA_TAG = 'tok';
export const TRANSFER_OF_KEEPERSHIP_BREEDER_ADESTRA_TAG = 'breeder';
export const FOUR_WEEKS_FREE_EMAIL_ADESTRA_TAG = 'petplan4weeksfree';
export const SCROLL_TO_OFFERS_QUERYPARAM = 'offers';

export enum UpdatedAfterThirdPartyCommunicationUserState {
  NotUpdated = 0,
  NotAffected = 1,
  Updated = 2,
}

export enum ActivateEmailStates {
  OngoingActivation,
  Activated,
  FailedActivation,
}
